export default function refreshAccessToken() {
  const infoRaw = localStorage.getItem("authInfo");
  if (!infoRaw) {
    console.log("[refreshAccessToken] no authInfo in localStorage");
    return;
  }

  let info = JSON.parse(infoRaw);
  let refreshToken = info.refresh_token; // Retrieve the refresh token from localStorage or any other storage mechanism

  if (!refreshToken) {
    console.log("[refreshAccessToken] no refresh_token, cannot refresh");
    return;
  }

  let tokenEndpoint = "https://oauth2.googleapis.com/token";

  const tokenParams = {
    client_id: process.env.REACT_APP_GOOGLE_COMET_SA,
    client_secret: process.env.REACT_APP_GOOGLE_COMET_SECRET,
    grant_type: "refresh_token",
    refresh_token: refreshToken,
  };
  // console.log(tokenParams); // for OAuth refresh & access token Debug

  fetch(tokenEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams(tokenParams),
  })
    .then((response) => response.json())
    .then((data) => {
      // New access token
      const accessToken = data.access_token;
      if (!accessToken) {
        console.error("[refreshAccessToken] no access_token in response", data);
        return;
      }

      // 1) accessToken도 별도 key로 캐시 (Sheets 페이지들에서 해당 키로 접근중)
      localStorage.setItem("accessToken", accessToken);

      // 2) checkOauthInfo가 보는 authInfo.access_token도 같이 업데이트
      info = {
        ...info,
        access_token: accessToken,
      };
      localStorage.setItem("authInfo", JSON.stringify(info));
      console.log("[refreshAccessToken] New access token cached:", accessToken);
    })
    .catch((error) => {
      console.error("Token refresh error:", error);
    });
}
